import i18n from '@viterbit/web-app/i18n'

const LabelSeparator = () =>(
    <div className="flex items-center gap-x-4">
        <h4 className="flex-none text-sm font-semibold leading-6 text-primary-600">{i18n.t('billing:whatsIncluded').toUpperCase()}</h4>
        <div className="flex-auto h-px bg-gray-100" />
    </div>
)

export default LabelSeparator